
import { Link, NavLink, useNavigate } from 'react-router-dom'; import React from "react";

import { useAudio } from '../../context/AudioProvider';
import { useOffCanvas } from '../../context/OffCanvasProvider';
import SharePanel from './SharePanel';
import DonatePanel from './DonatePanel';
import LyricsPanel from './LyricsPanel';
import CreditsPanel from './CreditsPanel';
import DescriptionPanel from './DescriptionPanel';
import AlbumPanel from './AlbumsPanel';
import ArtistPanel from './ArtistPanel';
import ArtistAlbumsPanel from './ArtistAlbumsPanel';
import PlaylistsPanel from './PlaylistsPanel';
import SearchAlbumsPanel from './SearchAlbumsPanel';

import $ from 'jquery'; // Import jQuery

import share_icon from '../../assets/frontend/images/share_icon.png';
import donate_icon from '../../assets/frontend/images/donate_icon.png';
import lyrics_icon from '../../assets/frontend/images/lyrics_icon.png';
import instrumental_icon from '../../assets/frontend/images/instrumental_icon.png';
import description_icon from '../../assets/frontend/images/description_icon.png';
import artist_icon from '../../assets/frontend/images/artist_icon.png';
import credits_icon from '../../assets/frontend/images/credits_icon.png';
import search_icon from '../../assets/frontend/images/search_icon.png';
import plus_icon from '../../assets/frontend/images/plus_circle_icon_black.png';
import minus_icon from '../../assets/frontend/images/minus_circle_icon_black.png';
import go_to_icon from '../../assets/frontend/images/go_to_icon_2.png';

const FeatureOptionsPanel = ({ onClose, track, tracklist }) => {

    const {
        likedMap, toggleLikeTrack, toggleLikeTrack2,
    } = useAudio();

    const { push: openCanvas } = useOffCanvas();  // load offcanvas functions

    // COMPUTED isLiked (replaces the old useState)
    const safeLikedMap = likedMap || [];

    const likedTracksArray =
        Array.isArray(safeLikedMap.tracks)
            ? safeLikedMap.tracks
            : []; // normalize

    const isLiked =
        track && track.random_id
            ? likedTracksArray.some(item => item.random_id === track.random_id)
            : false;

    function openShare(e, track) {
        e.stopPropagation();

        openCanvas({
            component: SharePanel,
            props: {
                track: track,
                tracklist: tracklist,
            }
        });
    }

    function openDonate(e, track) {
        e.stopPropagation();

        openCanvas({
            component: DonatePanel,
            props: {
                track: track,
                tracklist: tracklist,
            }
        });
    }

    function openLyrics(e, track) {
        e.stopPropagation();

        openCanvas({
            component: LyricsPanel,
            props: {
                track: track,
                tracklist: tracklist,
            }
        });
    }
    function openCredits(e, track) {
        e.stopPropagation();

        openCanvas({
            component: CreditsPanel,
            props: {
                track: track,
                tracklist: tracklist,
            }
        });
    }
    function openDescription(e, track) {
        e.stopPropagation();

        openCanvas({
            component: DescriptionPanel,
            props: {
                track: track,
                tracklist: tracklist,
            }
        });
    }
    function openAlbum(e, track) {
        e.stopPropagation();

        openCanvas({
            component: AlbumPanel,
            props: {
                track: track,
                tracklist: tracklist,
            }
        });
    }
    function openArtist(e, track) {
        e.stopPropagation();

        openCanvas({
            component: ArtistPanel,
            props: {
                track: track,
                tracklist: tracklist,
            }
        });
    }
    function openArtistAlbums(e, track) {
        e.stopPropagation();

        openCanvas({
            component: ArtistAlbumsPanel,
            props: {
                track: track,
                tracklist: tracklist,
            }
        });
    }
    function openAddToPlaylists(e, track) {
        e.stopPropagation();

        openCanvas({
            component: PlaylistsPanel,
            props: {
                track: track,
                tracklist: tracklist,
            }
        });
    }
    function openRemoveFromPlaylists(e, track) {
        e.stopPropagation();

        openCanvas({
            component: PlaylistsPanel,
            props: {
                track: track,
                tracklist: tracklist,
            }
        });
    }
    function openSearchAlbums(e, track) {
        e.stopPropagation();

        openCanvas({
            component: SearchAlbumsPanel,
            props: {
                track: track,
                tracklist: tracklist,
            }
        });
    }
    function forceBlur(e) {
        const target = e.currentTarget;

        // The button will lose focus after 1/2 seconds
        if (target) {
            setTimeout(() => {
                requestAnimationFrame(() => {
                    target.blur();
                });
            }, 500);
        }
    }

    return (
        <div className="options-content">
            <div className="panel large p-20l-10s">
                <div className="horizontal-container justify-left gap-lg-md bb1-555 pb-10l-5s">
                    {track && tracklist.type === 'liked' && track.tracklistImageURL ? (
                        <span className="center-everything b1-555">
                            <img src={track.tracklistImageURL} alt={track.tracklistTitle} className="lighten-bright120per-contrast115per hide-for-small-only" width="50" />
                            <img src={track.tracklistImageURL} alt={track.tracklistTitle} className="lighten-bright120per-contrast115per show-for-small-only" width="35" />
                        </span>
                    ) : (
                        tracklist.type === 'liked' ? (
                        <span className="center-everything b1-555">
                            <img src={tracklist.image_url} alt={tracklist.title} className="hide-for-small-only" width="50" />
                            <img src={tracklist.image_url} alt={tracklist.title} className="show-for-small-only" width="35" />
                        </span>
                        ) : (
                        <span className="center-everything b1-555">
                            <img src={tracklist.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per hide-for-small-only" width="50" />
                            <img src={tracklist.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per show-for-small-only" width="35" />
                        </span>
                        )
                    )}
                    {track && tracklist.type === 'liked' && track.tracklistTitle ? (
                        <span className="">
                            <span className="font-source-sans font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">{track.title}</span>
                            <div className="font-source-sans font-size-18l-16m-14s font-weight-500 txt-fff letter-spacing-0px italic uppercasse pt-10l-5s">{track ? track.tracklistTitle : ''}</div>
                        </span>
                    ) : (
                        track && tracklist.type !== 'liked' ? (
                        <span className="">
                            <span className="font-source-sans font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">{track.title}</span>
                            <div className="font-source-sans font-size-18l-16m-14s font-weight-500 txt-fff letter-spacing-0px italic uppercasse pt-10l-5s">{tracklist ? tracklist.title : ''}</div>
                        </span>
                        ) : (
                        <span className="">
                            <span className="font-source-sans font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">{tracklist ? tracklist.title : ''}</span>
                        </span>
                        )
                    )}
                    {!track && !tracklist && (
                        <span className="">
                            <div className="font-poppins font-size-16 font-weight-500 txt-fff">No track or tracklist loaded</div>
                        </span>
                    )}
                    {track && (
                        <span className="align-right">
                            <button className={`player-button-transparent liked ${isLiked ? 'active' : ''}`}
                                tabIndex="-1"
                                onPointerDown={(e) => e.preventDefault()}
                                onPointerUp={(e) => {
                                    e.stopPropagation();
                                    toggleLikeTrack2(track, tracklist);
                                    // force blur on mobile
                                    forceBlur(e);
                                }}
                            >
                            </button>
                        </span>
                    )}
                </div>

                <div className="horizontal-container justify-left gap-lg-md ptb-15l-12s">
                    <Link onClick={(e) => openShare(e, track)}>
                        <div className="horizontal-container justify-left gap-lg-md">
                            <span className="">
                                <img src={share_icon} alt="Share Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                <img src={share_icon} alt="Share Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                            </span>
                            <span className="font-poppins font-size-18l-16m font-weight-500">Share</span>
                        </div>
                    </Link>
                    <Link onClick={(e) => openDonate(e, track)} className="align-right">
                        <div className="horizontal-container justify-right gap-lg-md">
                            <span className="">
                                <img src={donate_icon} alt="Donate Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                <img src={donate_icon} alt="Donate Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                            </span>
                            <span className="font-poppins font-size-18l-16m font-weight-500">Donate</span>
                        </div>
                    </Link>
                </div>
                {track ? (
                    <div className="horizontal-container justify-left gap-lg-md ptb-15l-12s">
                        {track.lyrics && track.lyrics !== '' ? (
                            <Link onClick={(e) => openLyrics(e, track)}>
                                <div className="horizontal-container justify-left gap-lg-md">
                                    <span className="">
                                        <img src={lyrics_icon} alt="Lyrics Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                        <img src={lyrics_icon} alt="Lyrics Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                                    </span>
                                    <span className="font-poppins font-size-18l-16m font-weight-500" >Lyrics</span>
                                </div>
                            </Link>
                        ) : (
                            <span className="feature-disabled">
                                <div className="horizontal-container justify-left gap-lg-md">
                                    <span className="">
                                        <img src={instrumental_icon} alt="Instrumental Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                        <img src={instrumental_icon} alt="Instrumental Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                                    </span>
                                    <span className="font-poppins font-size-18l-16m font-weight-500 txt-bbb" >Instrumental</span>
                                </div>
                            </span>
                        )}
                        <Link onClick={(e) => openCredits(e, track)} className="align-right">
                            <div className="horizontal-container justify-left gap-lg-md ">
                                <span className="">
                                    <img src={credits_icon} alt="Credits Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                    <img src={credits_icon} alt="Credits Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                                </span>
                                <span className="font-poppins font-size-18l-16m font-weight-500" >Credits</span>
                            </div>
                        </Link>
                    </div>
                ) : (
                    <div className="horizontal-container justify-left gap-lg-md ptb-15l-12s">
                        {tracklist.type !== 'playlist' ? (
                            <Link onClick={(e) => openDescription(e, track)}>
                                <div className="horizontal-container justify-left gap-lg-md">
                                    <span className="">
                                        <img src={description_icon} alt="Description Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                        <img src={description_icon} alt="Description Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                                    </span>
                                    <span className="font-poppins font-size-18l-16m font-weight-500">Description</span>
                                </div>
                            </Link>
                        ) : (
                            <span className="feature-disabled">
                                <div className="horizontal-container justify-left gap-lg-md">
                                    <span className="">
                                        <img src={description_icon} alt="Description Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                        <img src={description_icon} alt="Description Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                                    </span>
                                    <span className="font-poppins font-size-18l-16m font-weight-500 txt-bbb">Description</span>
                                </div>
                            </span>
                        )}
                        <Link onClick={(e) => openCredits(e, track)} className="align-right">
                            <div className="horizontal-container justify-left gap-lg-md ">
                                <span className="">
                                    <img src={credits_icon} alt="Credits Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                    <img src={credits_icon} alt="Credits Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                                </span>
                                <span className="font-poppins font-size-18l-16m font-weight-500" >Credits</span>
                            </div>
                        </Link>
                    </div>
                )}
                {track && (
                    <div className="horizontal-container justify-left gap-lg-md ptb-15l-12s">
                        {track.description && track.description !== '' ? (
                            <Link onClick={(e) => openDescription(e, track)}>
                                <div className="horizontal-container justify-left gap-lg-md">
                                    <span className="">
                                        <img src={description_icon} alt="Description Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                        <img src={description_icon} alt="Description Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                                    </span>
                                    <span className="font-poppins font-size-18l-16m font-weight-500">Description</span>
                                </div>
                            </Link>
                        ) : (
                            <span className="feature-disabled">
                                <div className="horizontal-container justify-left gap-lg-md">
                                    <span className="">
                                        <img src={description_icon} alt="Description Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                        <img src={description_icon} alt="Description Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                                    </span>
                                    <span className="font-poppins font-size-18l-16m font-weight-500 txt-bbb">Description</span>
                                </div>
                            </span>
                        )}
                        {tracklist.type !== 'album' && (
                            <Link onClick={(e) => openAlbum(e, track)} className="align-right">
                                <div className="horizontal-container justify-left gap-lg-md">
                                    <span className="">
                                        <img src={go_to_icon} alt="Share Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                        <img src={go_to_icon} alt="Share Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                                    </span>
                                    <span className="font-poppins font-size-18l-16m font-weight-500">Album</span>
                                </div>
                            </Link>
                        )}
                    </div>
                )}
                <div className="horizontal-container justify-left gap-lg-md ptb-15l-12s">
                    <Link onClick={(e) => openArtist(e, track)}>
                        <div className="horizontal-container justify-left gap-lg-md">
                            <span className="">
                                <img src={artist_icon} alt="Artist Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                <img src={artist_icon} alt="Artist Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                            </span>
                            <span className="font-poppins font-size-18l-16m font-weight-500">Artist</span>
                        </div>
                    </Link>
                    <Link onClick={(e) => openArtistAlbums(e, track)} className="align-right">
                        <div className="horizontal-container justify-left gap-lg-md">
                            <span className="">
                                <img src={go_to_icon} alt="Share Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                <img src={go_to_icon} alt="Share Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                            </span>
                            <span className="font-poppins font-size-18l-16m font-weight-500">Artist Albums</span>
                        </div>
                    </Link>
                </div>
                <div className="horizontal-container justify-left gap-lg-md ptb-15l-12s">
                    <Link onClick={(e) => openAddToPlaylists(e, track)}>
                        <div className="horizontal-container justify-left gap-lg-md">
                            <span className="">
                                <img src={plus_icon} alt="Share Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                <img src={plus_icon} alt="Share Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                            </span>
                            <span className="font-poppins font-size-18l-16m font-weight-500">Playlists</span>
                        </div>
                    </Link>
                    {tracklist.type === 'playlist' && (
                        <Link onClick={(e) => openRemoveFromPlaylists(e, track)} className="align-right">
                            <div className="horizontal-container justify-left gap-lg-md">
                                <span className="">
                                    <img src={minus_icon} alt="Share Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                                    <img src={minus_icon} alt="Share Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                                </span>
                                <span className="font-poppins font-size-18l-16m font-weight-500">Playlists</span>
                            </div>
                        </Link>
                    )}
                </div>
                <Link onClick={(e) => openSearchAlbums(e, track)}>
                    <div className="horizontal-container justify-left gap-lg-md ptb-15l-12s">
                        <span className="">
                            <img src={search_icon} alt="Share Icon" className="icon hide-for-small-only" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                            <img src={search_icon} alt="Share Icon" className="icon show-for-small-only" style={{ width: '20px', height: '20px', marginRight: '3px' }} />
                        </span>
                        <span className="font-poppins font-size-18l-16m font-weight-500">Search</span>
                    </div>
                </Link>

                <div className="horizontal-container justify-right bt1-555 ptb-10 pr-10">
                    <Link className="font-poppins font-size-18l-16m font-weight-500" onClick={onClose}>Close</Link>
                </div>
            </div >
        </div >
    );
};

export default FeatureOptionsPanel;
